import React from "react";
import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import PaymentDetailMain from "./PaymentDetailMain";
import PaymentGrid from "./PaymentGrid";
import {
  ItemsStore,
  PaymentStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";
import { Loader } from "@mindmemobile/mm-shared-global";

type IProps = {
  paymentStore: PaymentStore;
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
};

const PaymentRoutes: React.FC<IProps> = ({
  itemStore,
  paymentStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <PaymentGrid
            paymentStore={paymentStore}
            itemStore={itemStore}
            merchantAccountStore={merchantAccountStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
          />
        }
      />
      <Route
        path={`/detail/:id/`}
        element={
          <PaymentDetailMain
            itemStore={itemStore}
            paymentStore={paymentStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
    </Routes>
  );
};
export default observer(PaymentRoutes);
